import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { BoatTypeRef } from "./BoatTypeRef";
import type { BoatTypeStaff } from "./BoatTypeStaff";
import type { PersonStaff } from "./PersonStaff";
import type { ProfilePersonBase } from "./ProfilePersonBase";
import type { ProgramTypeRef } from "./ProgramTypeRef";
import type { ProgramTypeStaff } from "./ProgramTypeStaff";
import type { RatingRef } from "./RatingRef";
import type { RatingStaff } from "./RatingStaff";
import type { SignoutDTOBase } from "./SignoutDTOBase";
import type { TrackedBase } from "./TrackedBase";

export class SignoutStaff implements SignoutDTOBase, TrackedBase, ProfilePersonBase {
  constructor(public readonly signoutId: number, public readonly personId: PersonStaff | null, public readonly programId: ProgramTypeStaff | null, public readonly boatId: BoatTypeStaff | null, public readonly cardNum: string | null, public readonly sailNumber: string | null, public readonly hullNumber: string | null, public readonly signoutDatetime: Date | null, public readonly signinDatetime: Date | null, public readonly testRatingId: RatingStaff | null, public readonly testResult: string | null, public readonly signoutType: string, public readonly didCapsize: boolean | null, public readonly isQueued: boolean, public readonly queueOrder: number | null, public readonly comments: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly programIdTargetIds: ProgramTypeRef, public readonly boatIdTargetIds: BoatTypeRef, public readonly testRatingIdTargetIds: RatingRef | null, public readonly skipperId: number | null, public readonly skipperName: string | null, public readonly programName: string | null, public readonly boatName: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.programIdLoaded = this.programId != null;
    this.programIdCached = this.programId;
    this.boatIdLoaded = this.boatId != null;
    this.boatIdCached = this.boatId;
    this.testRatingIdLoaded = this.testRatingId != null;
    this.testRatingIdCached = this.testRatingId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private programIdLoaded: boolean;
  private programIdCached: ProgramTypeStaff | null;
  private boatIdLoaded: boolean;
  private boatIdCached: BoatTypeStaff | null;
  private testRatingIdLoaded: boolean;
  private testRatingIdCached: RatingStaff | null;
  async personIdLazy(): Promise<PersonStaff | null> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getSignoutStaffPersonId(this.signoutId);
      this.personIdLoaded = true;
    }
    return this.personIdCached;
  }
  async programIdLazy(): Promise<ProgramTypeStaff> {
    if (!this.programIdLoaded) {
      this.programIdCached = await this.cbiServiceContext!.programTypeService().getProgramTypeStaff(this.programIdTargetIds.programId);
      this.programIdLoaded = true;
    }
    return this.programIdCached!;
  }
  async boatIdLazy(): Promise<BoatTypeStaff> {
    if (!this.boatIdLoaded) {
      this.boatIdCached = await this.cbiServiceContext!.appDataService().getBoatTypeStaff(this.boatIdTargetIds.boatId);
      this.boatIdLoaded = true;
    }
    return this.boatIdCached!;
  }
  async testRatingIdLazy(): Promise<RatingStaff | null> {
    if (!this.testRatingIdLoaded) {
      this.testRatingIdCached = await (this.testRatingIdTargetIds != null ? this.cbiServiceContext!.ratingService().getRatingStaff(this.testRatingIdTargetIds.ratingId) : Promise.resolve(null));
      this.testRatingIdLoaded = true;
    }
    return this.testRatingIdCached;
  }
}
